import { createReducer, on } from '@ngrx/store';
import { withEntityReducer, withListReducer } from '@aston/foundation';

import * as featureActions from './actions';
import { initialState, IFederationDetailState } from './state';


// declare our fully typed reducer
export const FederationDetailStoreReducer = createReducer<IFederationDetailState>(
	initialState,

	...withListReducer<IFederationDetailState>('usersList', featureActions.usersListActions),
	...withEntityReducer<IFederationDetailState>('federationForm', featureActions.currentFederationActions),
	...withEntityReducer<IFederationDetailState>('transientUserStatus', featureActions.updateTransientUserStatusActions),

	on(featureActions.ToggleIsEditingFederation, state => ({
		...state,
		federationFormIsEditing: !state.federationFormIsEditing
	})),

	on(featureActions.LoadFederationRequest, (state, action) => ({
		...state,
		currentFederationId: action.id,
		federationFormIsEditing: false,
		federationForm: {
			...state.federationForm,
			error: null
		}
	})),

	on(featureActions.UpdateFederationSuccess, state => ({
		...state,
		federationFormIsEditing: false
	})),

	on(featureActions.SetActiveModal, (state, action) => ({
		...state,
		activeModal: action.modal,
	})),
);
